import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgEvolutionCompute = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-evolution-compute';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M8.26 4.241 4.108 6.582l-.472.265.162.294c.089.163.162.314.162.337 0 .026-.136.042-.36.042h-.36l.001 4.71.001 4.71 4.162 2.34a1005 1005 0 0 0 4.197 2.353c.019.007.112-.124.207-.29s.181-.302.192-.302.098.136.192.302c.095.166.188.297.207.29s1.908-1.066 4.197-2.353l4.162-2.34V12l-.001-4.94-4.344-2.44c-2.389-1.342-4.373-2.443-4.409-2.447s-1.72.926-3.744 2.068m7.395 1.676 3.585 2.018v8.136l-2.675 1.504-3.24 1.822-.565.318v-2.78l1.99-1.119 1.99-1.12V9.309l-2.37-1.333L12 6.642l-1.989 1.119A131 131 0 0 1 8 8.88c-.055 0-2.405-1.344-2.406-1.377-.002-.051 6.332-3.619 6.411-3.61.035.004 1.678.915 3.65 2.024M13.636 9.28l1.602.9.001 1.82.001 1.82-1.207.68c-.664.374-1.222.686-1.24.693-.018.008-.033-.805-.033-1.805v-1.819l-1.599-.895c-.879-.492-1.599-.904-1.6-.916-.001-.029 2.41-1.394 2.446-1.385.014.004.748.412 1.629.907m-7.325.38.927.52.011 2.258.011 2.258 1.99 1.12 1.99 1.119v2.78l-.565-.318-3.24-1.822-2.675-1.504V8.795l.312.173c.172.094.729.406 1.239.692m3.889 2.19 1.02.574.011 1.391c.005.766-.005 1.386-.024 1.379-.018-.008-.576-.32-1.24-.694l-1.207-.68v-2.781l.21.119z"
    })
  }));
});
export default SvgEvolutionCompute;